import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPedals = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 20 20",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M13.057 1.75c-.931 0-1.68.75-1.68 1.68V16.57c0 .93.75 1.68 1.68 1.68h4.887c.931 0 1.68-.75 1.68-1.68V3.43c0-.931-.75-1.68-1.68-1.68zm-11 5.5c-.93 0-1.68.749-1.68 1.68v7.639c0 .93.75 1.68 1.68 1.68h4.889c.93 0 1.68-.75 1.68-1.68v-7.64c0-.93-.75-1.68-1.68-1.68z" })
});
export default SvgPedals;
